import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-refresh-renderer',
    templateUrl: './refresh-renderer.component.html',
    styleUrls: ['./refresh-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class RefreshRendererComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
